import { useState } from 'react';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd, faClose, faBriefcase} from "@fortawesome/free-solid-svg-icons";

import './accordion.css';

function Accordion({work}) {
    const headerId = 'accordion-header' + work.title;
    const panelId = 'accordion-panel' + work.title;

    const [toggle, setToggle] = useState(false);
    
  return (
    <>
        <h3 className="accordion__header" 
                onClick={() => setToggle(!toggle)}>
            <div id={headerId}
                aria-expanded={toggle}
                aria-controls={panelId}
                className={`accordion__toggle`}
            >
                <div className='accordion__header__title'>
                    <div className="accordion__header__logo" >
                        <FontAwesomeIcon icon={faBriefcase} className='header__logo-icon'/>
                        <span className="header__title-link">{work.title}</span>
                    </div>
                    {toggle ? <FontAwesomeIcon icon={faClose} /> : <FontAwesomeIcon icon={faAdd} />}
                </div>
                <div className="accordion__header__subtitle">{work.company}</div>
                <div className="accordion__header__info"><span>{work.location}</span><span>{work.time}</span></div>
            </div>
            
        </h3>
        <section  id={panelId}
            className={`according__panel ${toggle ? 'open' : ''}`}
            aria-labelledby={headerId}
            hidden={!toggle}>
            {work.descriptions.map((item, index) => <p key={index} className='accordion__detail'>{item}</p>)}
        </section>
    </>
  );
}

export default Accordion;